import MmenuLight from 'mmenu-light/esm/core/index';

// mmenu Light
// https://mmenujs.com/mmenu-light/docs.html
function init_menu(){
    
    const mobile_menu = document.querySelector( "#mobile-menu" );
    
    if( mobile_menu ){
        const menu = new MmenuLight(
            document.querySelector( "#mobile-menu" ),
            "(max-width: 900px)"
        );
        const navigator = menu.navigation({
            // slidingSubmenus: false,
            slidingSubmenus: true,
            title: "Menu",
            theme: "dark"
        });
        const drawer = menu.offcanvas({
            position: "left"
        });
        
        document.querySelector( '.hamburger' ).addEventListener( 'click', function(e){
            e.preventDefault();
            drawer.open();
        });
    }

    function maybe_show_mobile_header(){

        let header = document.getElementById('header');

        if( ! header ){
            return;
        }

        let header_logo = header.querySelector(".site-branding img");

        if( window.innerWidth > 900 ){

            if( header.classList.contains('reversed') ){
                header_logo.src = header_logo.dataset.reversed;
            }else{
                header_logo.src = header_logo.dataset.default;
            }

        }else{ // always white logo on mobile
            header_logo.src = header_logo.dataset.reversed;
        }

    }

    // run on first load
    maybe_show_mobile_header();

    window.addEventListener( "resize", maybe_show_mobile_header );

}

export { init_menu };
